module.exports = __webpack_public_path__ + "img/job-search-app.9151dd55.png";